import React from "react";
import { Autocomplete, Box } from "@mui/material";
import { InputField } from "./InputField.styled";
import { HeaderText } from "../text/HeaderText.styled";
import { BodyText } from "../text/BodyText.styled";
import { dropdownSlotProps } from "../../styles/dropdown";

interface AutocompleteFieldProps<T> {
  options: T[];
  value: T | null;
  onChange: (value: T | null) => void;
  getOptionLabel: (option: T) => string;
  getOptionId: (option: T) => string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  loading?: boolean;
}

export function AutocompleteField<T>({
  options,
  value,
  onChange,
  getOptionLabel,
  getOptionId,
  label,
  placeholder,
  disabled = false,
  loading = false,
}: AutocompleteFieldProps<T>) {
  return (
    <Box>
      {label && <HeaderText sx={{ pb: "4px", fontSize: "12px" }}>{label}</HeaderText>}
      <Autocomplete<T>
        options={options}
        value={value}
        onChange={(_event, newValue) => onChange(newValue)}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={(option, selected) => getOptionId(option) === getOptionId(selected)}
        disabled={disabled}
        loading={loading}
        size="small"
        renderOption={(props, option) => (
          <li {...props} key={getOptionId(option)}>
            {getOptionLabel(option)}
          </li>
        )}
        loadingText={<BodyText>Loading...</BodyText>}
        noOptionsText={<BodyText>No options</BodyText>}
        renderInput={(params) => <InputField {...params} placeholder={placeholder} variant="outlined" />}
        slotProps={dropdownSlotProps}
      />
    </Box>
  );
}

export default AutocompleteField;
